import loadable from "@loadable/component";
import { getLoading } from "@sprout/views";
export default loadable(()=>{
    return import("./PrioritiesPage");
}, {
    fallback: getLoading()
});
